module.exports = __webpack_public_path__ + "img/alert1.png";